import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LoadingActions from '../actions';
import { getIsPromisePending } from '../../pending-promises';

const withLoading = ComposedComponent => class withLoading
  extends React.Component {
  static propTypes = {
    loadingActions: PropTypes.objectOf(PropTypes.func),
  };

  componentWillMount() {
    if (ComposedComponent.promises) {
      this.props.loadingActions.add(ComposedComponent.promises);
    }
  }

  componentWillUnmount() {
    if (ComposedComponent.promises) {
      this.props.loadingActions.remove(ComposedComponent.promises);
    }
  }

  render() {
    // remove our prop then spread remaining to composed component
    const { loadingActions, ...props } = this.props; //eslint-disable-line no-unused-vars
    return <ComposedComponent {...props} />;
  }
};

const mapStateToProps = ComposedComponent => state => ({
  // this is added to pass to the componentComponent to know if its promise is pending
  isLoading: getIsPromisePending(state, {
    promises: ComposedComponent.promises,
  }),
});

const mapDispatchToProps = dispatch => ({
  loadingActions: bindActionCreators(LoadingActions, dispatch),
});

export default (...args) =>
  connect(mapStateToProps(...args), mapDispatchToProps)(withLoading(...args));



// WEBPACK FOOTER //
// ./src/redux-modules/loading-overlay/components/withLoading.js